import { FunctionComponent } from "react";
import useName from "components/company/CompanyLayout/CompanyBanner/useName";
import InfoBanner from "components/shared/InfoBanner";
import PageTitle from "components/shared/PageTitle";
import CompanyRiskFlag from "components/company/CompanyRiskFlag";
import { useSelector } from "react-redux";
import companySelectors from "store/selectors/company";
import { selectors } from "store";

const CompanyBanner: FunctionComponent = function ({}) {
  const name = useName();
  const isLoading = useSelector(selectors.getIsLoading);
  const company = useSelector(companySelectors.getEntity);

  return (
    <>
      <PageTitle>{name}</PageTitle>
      <InfoBanner
        title={name}
        isLoading={isLoading}
        icon={<CompanyRiskFlag className="mt-1 ml-1" id={company?.id} />}
      />
    </>
  );
};

export default CompanyBanner;
